import { render, staticRenderFns } from "./ClientGlucoseChart.vue?vue&type=template&id=2c1626af&scoped=true"
import script from "./ClientGlucoseChart.vue?vue&type=script&lang=js"
export * from "./ClientGlucoseChart.vue?vue&type=script&lang=js"
import style0 from "./ClientGlucoseChart.vue?vue&type=style&index=0&id=2c1626af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1626af",
  null
  
)

export default component.exports